/** @prettier */

import {Grid, FormControlLabel, Checkbox, Box, Stack} from '@mui/material';
import {Auth} from 'aws-amplify';
import {useState} from 'react';
import {Link} from 'react-router-dom';

//MTH component import
import {ChkInputTextbox} from '../../component/ChkInputTextbox';
import LoginFooter from '../../component/LoginFooter';
import {PrimaryButton} from '../../component/BasicButton';
//Style import
import '../../css/common/common.css';

import {routeList} from '../PrivateRoute';
import {format} from '../../define';

/**
 * 新規ユーザ登録
 * @returns JSX
 */
const RegisterAccount = () => {
  const [emailAddr, setEmailAddr] = useState(''); //メールアドレス
  const [password, setPassword] = useState(''); //パスワード
  const [reEnterPassword, setReEnterPassword] = useState(''); //パスワード（2回目の入力）
  const [checkBox, setCheckBox] = useState(false); //チェックボックス
  const [addDisabledRegister, setAddDisabledRegister] = useState(true); //REGISTERボタン有効フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  //TextBoxのエラー状態
  const [emailAddrError, setEmailAddrError] = useState(false); //メールアドレス
  const [passwordError, setPasswordError] = useState(false); //パスワード

  //フォーマット正常フラグ
  const [emailCheck, setEmailCheck] = useState(true); //メールアドレス
  const [passwordCheck, setPasswordCheck] = useState(true); //パスワード
  const [passMatchCheck, setPassMatchCheck] = useState(true); //パスワード（2回目の入力）

  /**
   * チェックボックス状態判定
   * @param event
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckBox(event.target.checked);
  };

  /**
   * 入力チェック
   * @returns
   */
  const formDataCheck = () => {
    /** 入力エラーフラグ */
    let isError = true;

    setEmailCheck(true);
    setPassMatchCheck(true);
    setPasswordCheck(true);

    //メールアドレス形式チェック
    /* メールアドレスの正規表現 */
    const regex = format.EMAIL_PATTERN_OK;
    if (regex.test(emailAddr) === false) {
      // メールアドレス規則エラー
      isError = false;
      setEmailCheck(false);
    }
    //パスワード形式チェック
    if (
      password.search(/[A-Z]/) === -1 || // パスワード - 大文字アルファベット
      password.search(/[a-z]/) === -1 || // パスワード - 小文字アルファベット
      password.search(/[0-9]/) === -1 || // パスワード - 数字
      password.search(/[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/) === -1 || // パスワード - 記号
      (emailAddr.slice(0, emailAddr.indexOf('@')).length > 0 && //@より前に文字列が存在する
        password.search(emailAddr.slice(0, emailAddr.indexOf('@'))) !== -1) || // パスワードにユーザIDが含まれる
      password.length < format.PASSWORD_LENGTH_MIN // パスワード - 文字数 10文字以上
    ) {
      // パスワード規則エラー
      isError = false;
      setPasswordCheck(false);
    }
    if (password !== reEnterPassword) {
      // パスワード一致エラー
      isError = false;
      setPassMatchCheck(false);
    }

    return isError;
  };

  /**
   * REGISTERボタン押下時処理
   * @param e
   */
  const onRegister = async (e: React.MouseEvent) => {
    setAPIWait(true);
    if (formDataCheck()) {
      try {
        /**
         * アカウント登録処理
         * 左側はAWS Cognitoに設定した属性名、
         * 右側にプログラム内で使用している変数名を書く。
         * カスタム属性の場合は'custom:****:xxxxx,'
         */
        await Auth.signUp({
          username: emailAddr,
          password: password,
          attributes: {
            email: emailAddr,
          },
        });
        alert('Send an e-mail. Click the link to complete the verify.');
        window.location.href = routeList.login.path;
      } catch (error: any) {
        //既にメールアドレスが登録されている場合
        if (error.code === 'UsernameExistsException') {
          alert(
            'The address entered is already registered.\nIf you have received an invitation email from M-ACCESS, please log in with the temporary password.'
          );
        } else {
          //アカウント登録失敗時はアラートを表示
          alert('SignUp Failure!');
        }
        setAPIWait(false);
      }
    } else {
      setAPIWait(false);
    }
  };

  /**
   * REGISTERボタン出現処理
   * @returns JSX
   */
  const AddRegisterButton = () => {
    if (
      //TextBoxにデータが入力されているかチェック
      emailAddr === '' ||
      password === '' ||
      reEnterPassword === '' ||
      checkBox === false ||
      //TextBoxの入力規則違反に対するエラー判定
      emailAddrError === true ||
      passwordError === true ||
      //API処理中判定
      apiWait === true
    ) {
      setAddDisabledRegister(true);
    } else {
      setAddDisabledRegister(false);
    }

    //TextBoxにErrorが無い場合は、REGISTERボタンを表示
    //Errorが有る場合は、REGISTERボタンをDisabled
    return (
      <PrimaryButton
        onClick={onRegister}
        buttonText={'REGISTER'}
        id="mv-btnRegister"
        disabled={addDisabledRegister}
        className="loginMain__leftFrame__input__button--register"
        apiWait={apiWait}
      />
    );
  };

  return (
    <Grid container className="loginMain">
      {/* 登録フォーム側 */}
      <Grid item xs={12} md={6} className="loginMain__leftFrame">
        <Stack className="loginMain__leftFrame">
          <Box className="loginMain__leftFrame__input">
            <Stack
              spacing={2}
              className="loginMain__leftFrame__input__contents">
              <h1>No Account? Register now.</h1>
              {/* 入力されたパスワードが一致しない場合は、警告文を表示 */}
              {emailCheck === false ? (
                <Box className="loginMain__leftFrame__input__contents__errorText">
                  The email address is in an invalid format.
                </Box>
              ) : (
                <></>
              )}
              {passwordCheck === false ? (
                <Box className="loginMain__leftFrame__input__contents__errorText">
                  The password is in an invalid format.
                </Box>
              ) : (
                <></>
              )}
              {passMatchCheck === false ? (
                <Box className="loginMain__leftFrame__input__contents__errorText">
                  Passwords do not match. Please try again.
                </Box>
              ) : (
                <></>
              )}
              {/* メールアドレス入力テキストボックス */}
              <ChkInputTextbox
                setValue={setEmailAddr}
                setError={setEmailAddrError}
                chkInputTxtError={format.BASIC_PATTERN_ERROR}
                chkLength={format.EMAIL_LENGTH_MAX}
                type="text"
                label="E-mail address*"
                value={emailAddr}
                id="mv-inputLoginUser"
                helperText=" "
                errHelperText="Incorrect entry."
                variant="standard"
                autoFocus={true}
              />
              {/* パスワード入力テキストボックス */}
              <ChkInputTextbox
                setValue={setPassword}
                setError={setPasswordError}
                chkInputTxtOK={format.PASSWORD_PATTERN_OK}
                chkLength={format.PASSWORD_LENGTH_MAX}
                type="password"
                label="Password*"
                value={password}
                id="mv-inputLoginPassword"
                helperText={`The password must be at least ${format.PASSWORD_LENGTH_MIN} characters long including the following; At least one lowercase and uppercase character, a number and a symbol. It must not include any details of your email address.`}
                errHelperText="Incorrect entry."
                variant="standard"
              />
              {/* 確認用パスワード入力テキストボックス */}
              <ChkInputTextbox
                setValue={setReEnterPassword}
                setError={setPasswordError}
                chkInputTxtOK={format.PASSWORD_PATTERN_OK}
                chkLength={format.PASSWORD_LENGTH_MAX}
                type="password"
                label="Confirm password*"
                value={reEnterPassword}
                id="mv-inputLoginRePassword"
                helperText=" "
                errHelperText="Incorrect entry."
                variant="standard"
              />
              {/** 規約への同意のお願い */}
              <Box>
                In order to proceed with creating an M-ACCESS account and using
                the M-ACCESS Service, please confirm that you have read the
                M-ACCESS Service Privacy Policy and User terms, agree to the
                basis upon which we will collect and process your Personal Data
                and Technical Data.
              </Box>
              {/** 規約 */}
              <Box className="loginMain__leftFrame__input__contents__registerAccountServiceInfo__contents">
                <Box
                  component="span"
                  className="loginMain__leftFrame__input__contents__registerAccountServiceInfo__contents--underlineFont">
                  Acknowledgement of the M-ACCESS Privacy Policy
                  <br />
                </Box>
                <Box component="p">
                  I acknowledge that I have read and understood the information
                  in&nbsp;
                  <Link
                    to={routeList.privacyPolicy.path}
                    id="mv-PrivacyPolicyOfService"
                    target="_blank">
                    the M-ACCESS Privacy Policy
                  </Link>
                  &nbsp;regarding the collection and use of my Personal Data.
                </Box>
                <Box
                  component="span"
                  className="loginMain__leftFrame__input__contents__registerAccountServiceInfo__contents--underlineFont">
                  Consent to the collection and use of Technical Data under
                  e-Privacy Laws
                  <br />
                </Box>
                <Box component="p">
                  To ensure that MTH's collection and use of Technical Data is
                  in compliance with EEA and UK e-Privacy laws, I hereby
                  consent, on behalf of myself or the organisation which I
                  represent, to Technical Data being collected by MTH from the
                  Unit(s) installed on the Site(s) for which I am, or my
                  organisation is, responsible and used by MTH to provide the
                  M-ACCESS Service and related purposes. This consent is given
                  freely. I am aware that I or my organisation may revoke this
                  consent at any given time by deleting the M-ACCESS Service
                  account. I understand that if consent is revoked by deleting
                  the account then I or my organisation shall no longer be able
                  to use the M-ACCESS Service and that any collection and
                  processing of Technical Data which took place before consent
                  was revoked will remain lawful.
                </Box>
                <Box
                  component="span"
                  className="loginMain__leftFrame__input__contents__registerAccountServiceInfo__contents--underlineFont">
                  Acknowledgement of the M-ACCESS User terms
                  <br />
                </Box>
                <Box component="p">
                  I acknowledge that I have read and understood the information
                  in&nbsp;
                  <Link
                    to={routeList.registerAccountTermsOfService.path}
                    id="mv-UsersTermsOfService"
                    target="_blank">
                    the M-ACCESS User terms.
                  </Link>
                </Box>
              </Box>
              {/** チェックボックス */}
              <FormControlLabel
                control={
                  <Checkbox onChange={handleChange} id={'mv-checkboxAccept'} />
                }
                checked={checkBox}
                label="I agree with the above 3 items"
              />
              {/** REGISTERボタン */}
              <Box className="loginMain__leftFrame__input__contents__button">
                {/** REGISTERボタンはすべての項目が入力されるまで白塗り */}
                <AddRegisterButton />
              </Box>
              <Box className="loginMain__leftFrame__input__contents__description">
                Already got an account?&nbsp;
                <Link to={routeList.login.path} id="mv-linkLogin">
                  Login now.
                </Link>
              </Box>
            </Stack>
          </Box>
          <LoginFooter />
        </Stack>
      </Grid>
      {/* 画像表示側 */}
      <Grid
        item
        xs={0}
        md={6}
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/img/mysite/login/resister.webp)`,
        }}
        className="loginMain__backgroundImageIn"></Grid>
    </Grid>
  );
};
export default RegisterAccount;
